export default {"src":"/_next/static/media/input-check-icon.58642ebb.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};